import { Component, OnInit, effect, inject } from '@angular/core';
import { SharedSignalsService } from '../../../common/services/shared-signals.service';
import { TranslationService } from '../../../common/services/translation.service';

interface ContentItem {
  icon: string;
  value: string;
  desc: string;
}

@Component({
  selector: 'taly-business-with-taly',
  templateUrl: './business-with-taly.component.html',
  styleUrls: ['./business-with-taly.component.scss'],
  standalone: false,
})
export class BusinessWithTalyComponent implements OnInit {
  transferSignal = inject(SharedSignalsService);
  translationService = inject(TranslationService);
  textDirection!: string;

  benefits: ContentItem[] = [
    {
      icon: 'assets/images/Order.svg',
      value: '+41%',
      desc: this.translationService.getLabelValue('LEARN_MORE_PAGE.COUNT_DESC_1'),
    },
    {
      icon: 'assets/images/Increase.svg',
      value: '+30%',
      desc: this.translationService.getLabelValue('LEARN_MORE_PAGE.COUNT_DESC_2'),
    },
    {
      icon: 'assets/images/Conversion-rate.svg',
      value: '+19%',
      desc: this.translationService.getLabelValue('LEARN_MORE_PAGE.COUNT_DESC_3'),
    },
    {
      icon: 'assets/images/Money.svg',
      value: '-20%',
      desc: this.translationService.getLabelValue('LEARN_MORE_PAGE.COUNT_DESC_4'),
    },
  ];

  constructor() {
    effect(() => {
      this.textDirection = this.transferSignal.textDirection();
      this.setBenefits();
    });
  }

  ngOnInit(): void {
    this.setBenefits();
  }

  setBenefits() {
    this.benefits = [
      {
        icon: 'assets/images/Order.svg',
        value: '+41%',
        desc: this.translationService.getLabelValue('LEARN_MORE_PAGE.COUNT_DESC_1'),
      },
      {
        icon: 'assets/images/Increase.svg',
        value: '+30%',
        desc: this.translationService.getLabelValue('LEARN_MORE_PAGE.COUNT_DESC_2'),
      },
      {
        icon: 'assets/images/Conversion-rate.svg',
        value: '+19%',
        desc: this.translationService.getLabelValue('LEARN_MORE_PAGE.COUNT_DESC_3'),
      },
      {
        icon: 'assets/images/Money.svg',
        value: '-20%',
        desc: this.translationService.getLabelValue('LEARN_MORE_PAGE.COUNT_DESC_4'),
      },
    ];
  }
}
